import React from "react";
import Row from "./Row";

interface TitleProps {
  label: React.ReactNode;
  isRequired?: boolean;
  orientation?: "col" | "row";
  vertical?: boolean;
  disabled?: boolean;
}

const Title = React.forwardRef((props: TitleProps, ref: React.Ref<HTMLDivElement>) => {
  const { label, isRequired, vertical = false, disabled = false } = props;

  return (
    <Row
      ref={ref}
      style={
        vertical
          ? { width: "100%", wordBreak: "break-word", color: disabled ? "var(--gray-200)" : "" }
          : {
              minWidth: "120px",
              width: "120px",
              maxWidth: "120px",
              wordBreak: "break-word",
              flex: 1,
              color: disabled ? "var(--gray-200)" : "",
            }
      }
      className="flex align-items-center pr-2 "
    >
      <span className="input-label">{label}</span>
      &nbsp; {isRequired ? <span style={{ color: "red" }}>{"*"}</span> : null}
    </Row>
  );
});

export default Title;
